module.exports = __webpack_public_path__ + "static/footer-map-80b0cb4fab6933f0cf7d485070e2fdd5.png";